"use client";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXs, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { ProductTileUI as ProductTileUI$1 } from "../../../Product/ProductTile/ProductTileUI/index.js";
import { ProductTileUI } from "../../../Product/ProductTileV2/ProductTileUI/index.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { Observable } from "./Observable.js";
function ObservableProductTileUI({
  analytics = {},
  itemNumber,
  isHorizontal = false,
  configData,
  productTileSx,
  productApiResponse,
  lwData,
  inventoryAware,
  locale,
  showActionButton,
  showReviews,
  showCompareProduct,
  variant,
  isSponsored,
  carouselIndexText,
  carouselTitle,
  dataPrivate,
  minProductTileImageWidth,
  maxProductTileImageWidth,
  hideReviewStarValue,
  productTileMaxLineNumber,
  maxImageHeight,
  containerSx,
  criteoDataSourceAttr,
  carouselIndexAriaText,
  pageType,
  isProductDetailsPage,
  isV1ProductTile,
  sponsoredDisplayVariant = "default",
  allowBatchApi = true,
  isCriteo = false,
  product_tile_data_source
}) {
  let analyticsValue;
  if (carouselTitle) {
    analyticsValue = `Product Tile | ${carouselTitle};pid:${itemNumber}`;
  }
  return /* @__PURE__ */ jsx(
    Observable,
    {
      observer: {
        minimumViewTime: analytics.minimumViewTime,
        onClick: () => {
          var _a;
          return (_a = analytics.onTileClicked) == null ? void 0 : _a.call(analytics, itemNumber);
        },
        onLoad: () => {
          var _a;
          return (_a = analytics.onTileLoad) == null ? void 0 : _a.call(analytics, itemNumber);
        },
        onView: () => {
          var _a;
          return (_a = analytics.onTileViewed) == null ? void 0 : _a.call(analytics, itemNumber);
        },
        viewThreshold: analytics.viewThreshold
      },
      sx: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        padding: isHorizontal ? 0 : SpaceXxs,
        paddingBottom: isHorizontal ? 0 : SpaceXs,
        textAlign: "start",
        ...containerSx
      },
      children: /* @__PURE__ */ jsxs(
        CostcoBox,
        {
          sx: { height: isProductDetailsPage ? "100%" : "inherit" },
          children: [
            !isV1ProductTile ? /* @__PURE__ */ jsx(
              ProductTileUI,
              {
                ariaLinkDescribedBy: carouselIndexAriaText ? `carouselProductTile-${itemNumber}-carouselIndexAriaText` : void 0,
                productApiResponse,
                lwData,
                allowBatchApi,
                addToCartAnalytics: analyticsValue,
                configData,
                criteoDataSourceAttr,
                dataPrivate,
                hideReviewStarValue,
                inventoryAware,
                isCriteo: carouselTitle === "Sponsored Products" || isCriteo,
                isHorizontal,
                isSponsored,
                itemNumber: productApiResponse == null ? void 0 : productApiResponse.itemNumber,
                locale,
                maxImageHeight,
                minProductTileImageWidth,
                maxProductTileImageWidth,
                pageType,
                isProductDetailsPage,
                productTileMaxLineNumber,
                product_tile_data_source,
                ratingVariant: "compact",
                showActionButton,
                showCompareProduct,
                showReviews,
                sx: { ...productTileSx },
                variant,
                enableAnalytics: !analytics.onTileClicked
              }
            ) : /* @__PURE__ */ jsx(
              ProductTileUI$1,
              {
                ariaLinkDescribedBy: carouselIndexAriaText ? `carouselProductTile-${itemNumber}-carouselIndexAriaText` : void 0,
                productApiResponse,
                lwData,
                configData,
                criteoDataSourceAttr,
                dataPrivate,
                hideReviewStarValue,
                inventoryAware,
                isHorizontal,
                isSponsored,
                itemNumber: productApiResponse == null ? void 0 : productApiResponse.itemNumber,
                locale,
                maxImageHeight,
                maxProductTileImageWidth,
                minProductTileImageWidth,
                pageType,
                productTileMaxLineNumber,
                product_tile_data_source,
                showActionButton,
                showCompareProduct,
                showReviews,
                sx: productTileSx,
                variant,
                allowBatchApi,
                enableAnalytics: !analytics.onTileClicked,
                sponsoredDisplayVariant
              }
            ),
            !!carouselIndexText && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                Text,
                {
                  sx: {
                    textAlign: "right"
                  },
                  "aria-hidden": "true",
                  color: "medium",
                  children: carouselIndexText
                }
              ),
              !!carouselIndexAriaText && /* @__PURE__ */ jsx(
                Text,
                {
                  sx: {
                    display: "none",
                    textAlign: "right"
                  },
                  color: "medium",
                  id: `carouselProductTile-${itemNumber}-carouselIndexAriaText`,
                  children: carouselIndexAriaText
                }
              )
            ] })
          ]
        }
      )
    },
    `carouselProductTile-${itemNumber}`
  );
}
export {
  ObservableProductTileUI
};
